// extracted by mini-css-extract-plugin
export default {"subtitle":"subtitle_subtitle__BalMG","skills":"subtitle_skills__eoUDh","template":"subtitle_template__XyGq9","skill":"subtitle_skill__rnocD"};